module.exports = __webpack_public_path__ + "img/check_mark_button_3d.edf72535.png";